<div class="effect-chico blog">
  <img src="{{ image }}" class="img-fluid" alt="img"/>
  <div class="blog-info">
    <ng-content select="[cardBody]"></ng-content>
  </div>
  <div class="blog-comment">
    <ng-content select="[cardFooter]"></ng-content>
  </div>
</div>
